'use strict';

import {
  setHtmlScrollable,
  setHtmlUnscrollable
} from '@jspartials/general-utils';
import {
  addClassToElement,
  removeClassToElement
} from '@jspartials/class-list-utils';

const mobileBreakpoint = window.matchMedia('(min-width: 768px)');

// Selectors
const selector = {
  modal: {
    id: '#productComposableOptionsModal',
    body: '.options-modal-body',
    container: '.options-container',
    header: '.options-header',
    imagesContainer: '.js-images-container',
    imagesModal: '.js-modal-images',
    dataOptionID: '[data-option-id]',
    partImages: '.js-modal-images [data-option-id]',
    titleProduct: '.js-options-title-product',
    stepsContainerOptionId: '.options-steps-container [data-option-id]',
    stepsContainerProducts: '.js-options-steps-copntainer-products',
    close: '#productComposableOptionsModal .close'
  },
  options: {
    optionsValueContainer:
      '#productComposableOptionsModal .option-value-container',
    selectedOption: '.js-selected-option',
    selectedRectOption: '.js-option-rect-selected',
    selectedNameOption: '.js-option-name-selected',
    selectedChevronIcon: '.js-option-chevron-icon',
    tabOptions: '.js-tab-options',
    optionValuesWrapper: '.js-option-values-wrapper',
    optionvalues: '.js-option-values',
    optionValueContainer: '.option-value-container',
    optionTitle: '.js-option-title',
    optionImages: '.js-composable-product-options-image',
    optionName: '.js-option-name',
    optionInput: '.js-option-input',
    polarized: '#polarized'
  },
  summary: {
    optionValuesSummary: '.js-option-values-summary',
    optionValueSummaryWrapper: '.js-option-value-summary-wrapper',
    optionPrice: '.js-option-price',
    priceElement: '.js-option-summary-price-sum',
    cartPriceElement: '[data-step-id="complete"] .cart-and-ipay .price .sales'
  },
  goNext: {
    optionValueError: '.option-value-error',
    optionValueGoNext: '.option-value-go-next'
  },
  extra: {
    selected: 'selected',
    show: 'show',
    error: 'error',
    enabled: 'enabled'
  }
};

// Elements
const element = {
  modal: {
    id: document.querySelector(selector.modal.id) || null,
    body: document.querySelector(selector.modal.body) || null,
    container: document.querySelector(selector.modal.container) || null,
    header: document.querySelector(selector.modal.header) || null,
    imagesContainer:
      document.querySelector(selector.modal.imagesContainer) || null,
    imagesModal: document.querySelector(selector.modal.imagesModal) || null,
    dataOptionID:
      document.querySelectorAll(selector.modal.dataOptionID) || null,
    partImages: document.querySelectorAll(selector.modal.partImages) || null,
    titleProduct: document.querySelector(selector.modal.titleProduct) || null,
    stepsContainerOptionId:
      document.querySelectorAll(selector.modal.stepsContainerOptionId) || null,
    stepsContainerProducts:
      document.querySelector(selector.modal.stepsContainerProducts) || null,
    close: document.querySelector(selector.modal.close) || null
  },
  options: {
    optionsValueContainer:
      document.querySelectorAll(selector.options.optionsValueContainer) || null,
    selectedOption:
      document.querySelector(selector.options.selectedOption) || null,
    selectedRectOption:
      document.querySelector(selector.options.selectedRectOption) || null,
    selectedNameOption:
      document.querySelector(selector.options.selectedNameOption) || null,
    selectedChevronIcon:
      document.querySelector(selector.options.selectedChevronIcon) || null,
    tabOptions: document.querySelector(selector.options.tabOptions) || null,
    optionValuesWrapper:
      document.querySelector(selector.options.optionValuesWrapper) || null,
    optionvalues: document.querySelector(selector.options.optionvalues) || null,
    optionValueContainer:
      document.querySelector(selector.options.optionValueContainer) || null,
    optionTitle: document.querySelector(selector.options.optionTitle) || null,
    optionImages: document.querySelector(selector.options.optionImages) || null,
    optionName: document.querySelector(selector.options.optionName) || null,
    optionInput:
      document.querySelectorAll(selector.options.optionInput) || null,
    polarized: document.querySelector(selector.options.polarized) || null
  },
  summary: {
    optionValuesSummary:
      document.querySelector(selector.summary.optionValuesSummary) || null,
    optionValueSummaryWrapper:
      document.querySelector(selector.summary.optionValueSummaryWrapper) ||
      null,
    optionPrice: document.querySelector(selector.summary.optionPrice) || null,
    priceElement: document.querySelector(selector.summary.priceElement) || null,
    cartPriceElement:
      document.querySelector(selector.summary.cartPriceElement) || null
  },
  goNext: {
    optionValueError:
      document.querySelector(selector.goNext.optionValueError) || null,
    optionValueGoNext:
      document.querySelector(selector.goNext.optionValueGoNext) || null
  }
};

//Functions
function autoSelection() {
  element.options.optionInput.forEach(function (item) {
    var selected = element.modal.stepsContainerProducts.querySelector(
      '[data-option-id="' + item.id + '"]'
    );

    if (selected) {
      var first = selected.querySelector(selector.options.optionTitle);
      first.click();
    }
  });
}

function closeModal() {
  setHtmlScrollable();
  removeClassToElement(element.modal.id, selector.extra.show);
  element.modal.body.setAttribute('data-current-step', 1);
  setTimeout(function () {
    element.modal.id.style.display = 'none';
  }, 200);
}

function openModal() {
  setHtmlUnscrollable();
  element.modal.id.style.display = 'block';
  setTimeout(function () {
    addClassToElement(element.modal.id, selector.extra.show);
  }, 50);
}

function setImage(selectedElement) {
  var currentPartId = selectedElement.dataset.optionId;
  var currentPartImage = selectedElement.dataset.optionImageUrl;

  element.modal.partImages.forEach(function () {
    var targetImage = Array.from(element.modal.partImages).find(
      (img) => img.dataset.optionId === currentPartId
    );
    if (targetImage) {
      targetImage.setAttribute('src', currentPartImage);
    }
  });
}

function updateSummary(selectedElement, partPrice) {
  var currentPartId = selectedElement.dataset.optionId;
  var currentPartVal = selectedElement.dataset.valueId;
  var currentPartTitle = selectedElement.dataset.title;
  var currentPartMainImage = selectedElement.dataset.optionImageUrl;
  var currentPartDisplayValue = selectedElement.dataset.valueTitle;
  var currentPartColorImage = selectedElement
    .querySelector(selector.options.optionImages)
    .getAttribute('src');
  var summaryElement = element.modal.id.querySelector(
    '.options-step[data-step-id="complete"] [data-option-id="' +
      currentPartId +
      '"]'
  );

  summaryElement
    .closest(selector.summary.optionValueSummaryWrapper)
    .querySelector('[name="' + currentPartId + '"]').value = currentPartVal;
  summaryElement
    .closest(selector.summary.optionValueSummaryWrapper)
    .querySelector('[name="' + currentPartId + '"]')
    .setAttribute('data-image', currentPartMainImage);
  summaryElement
    .closest(selector.summary.optionValueSummaryWrapper)
    .querySelector('[name="' + currentPartId + '"]')
    .setAttribute('data-title', currentPartTitle);
  summaryElement
    .closest(selector.summary.optionValueSummaryWrapper)
    .querySelector('[name="' + currentPartId + '"]')
    .setAttribute('data-displayvalue', currentPartDisplayValue);
  summaryElement.querySelector(selector.options.optionTitle).textContent =
    currentPartTitle;
  summaryElement
    .querySelector('.option-image img')
    .setAttribute('src', currentPartColorImage);

  if (partPrice !== 0) {
    summaryElement.querySelector(selector.summary.optionPrice).textContent =
      '+ ' + partPrice;
  } else {
    summaryElement.querySelector(selector.summary.optionPrice).textContent = '';
  }
}

function updatePriceElements(finalPrice) {
  updatePriceElement(element.summary.priceElement, finalPrice);
}

function updatePriceElement(priceElem, finalPrice) {
  var finalPriceArray = finalPrice.toFixed(2).toString().split('.');
  var currentPriceElement = priceElem.querySelector('.hw-product-price__sales');
  var sessionCurrency = currentPriceElement.getAttribute('data-currency');

  var finalPriceInt;
  var finalPriceDec;

  if (finalPriceArray.length > 0) {
    if (currentPriceElement.textContent.indexOf(sessionCurrency) == 0) {
      finalPriceInt = sessionCurrency + finalPriceArray[0];
      finalPriceDec =
        '<span class="tw-text-[75%] tw-relative tw-top-[-3px] tw-mr-0.5">.' +
        finalPriceArray[1] +
        '</span>';
    } else {
      finalPriceInt = finalPriceArray[0];
      finalPriceDec =
        '<span class="tw-text-[75%] tw-relative tw-top-[-3px] tw-mr-0.5">.' +
        finalPriceArray[1] +
        sessionCurrency +
        '</span>';
    }

    currentPriceElement.innerHTML = finalPriceInt + finalPriceDec;
  }
}

function selectOption(selectedElement) {
  Array.from(
    selectedElement.closest(selector.options.optionvalues).children
  ).forEach(function (element) {
    removeClassToElement(element, selector.extra.selected);
  });

  addClassToElement(selectedElement, selector.extra.selected);
  selectedElement
    .closest(selector.options.optionvalues)
    .querySelectorAll(selector.goNext.optionValueError)
    .forEach(function (element) {
      removeClassToElement(element, selector.extra.show);
    });
  removeClassToElement(
    selectedElement
      .closest(selector.options.optionvalues)
      .querySelector(selector.goNext.optionValueGoNext),
    selector.extra.error
  );
  addClassToElement(
    selectedElement
      .closest(selector.options.optionvalues)
      .querySelector(selector.goNext.optionValueGoNext),
    selector.extra.enabled
  );

  const imageSrc = selectedElement
    .querySelector(selector.options.optionImages)
    .getAttribute('src');

  const tabOptions = selectedElement.closest('.js-tab-options');

  tabOptions.previousElementSibling
    .querySelector(selector.options.selectedRectOption)
    .setAttribute('src', imageSrc);

  var partPrice = 0;
  if (
    Object.hasOwnProperty.call(
      window.optionModalConfig,
      selectedElement.dataset.optionId
    )
  ) {
    window.optionModalConfig[selectedElement.dataset.optionId].every(function (
      k
    ) {
      if (k.id === selectedElement.dataset.valueId && k.price.sales.value) {
        partPrice = k.price.sales.formatted;
        return false;
      }
      return true;
    });

    const title = selectedElement.querySelector(
      selector.options.optionName
    ).textContent;
    const titleWithPrice = partPrice !== 0 ? `${title} (+${partPrice})` : title;

    tabOptions.previousElementSibling.querySelector(
      selector.options.selectedNameOption
    ).textContent = titleWithPrice;

    tabOptions.querySelector(selector.options.selectedNameOption).textContent =
      titleWithPrice;
  }

  setImage(selectedElement);
  updateSummary(selectedElement, partPrice);

  document.body.dispatchEvent(new Event('composable::refreshPrice'));
}

function setGeneralListenersCreative() {
  element.modal.close.addEventListener('click', function (e) {
    e.preventDefault();
    closeModal();
  });

  element.options.optionsValueContainer.forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      var selectedElement = this;
      if (selectedElement) {
        selectOption(selectedElement);
      } else {
        addClassToElement(selectedElement, selector.extra.error);
        addClassToElement(
          selectedElement
            .closest(element.options.optionvalues)
            .querySelector(selector.goNext.optionValueError),
          selector.extra.show
        );
      }
    });
  });
}

function showPolarizedCheckbox() {
  var polarizedLenses = [];
  var nonPolarizedLenses = [];
  window.optionModalConfig['hk_creative_lenses_option'].forEach(function (
    item
  ) {
    if (!item.polarized) {
      nonPolarizedLenses.push(item);
    } else {
      polarizedLenses.push(item);
    }
  });

  if (nonPolarizedLenses.length === 0 || polarizedLenses.length === 0) {
    element.options.polarized.closest('.option-polarized').style.display =
      'none';
  }
}

if (element.options.polarized) {
  element.options.polarized.addEventListener('change', function (check) {
    const selectedcategory = check.target.dataset.id;

    if (check.target.checked) {
      window.optionModalConfig[selectedcategory].forEach(function (item) {
        if (!item.polarized) {
          element.modal.id.querySelector(
            '[data-value-id="' + item.id + '"]'
          ).style.display = 'none';
        }
      });
    } else {
      window.optionModalConfig[selectedcategory].forEach(function (item) {
        if (
          element.modal.id.querySelector('[data-value-id="' + item.id + '"]')
            .style.display === 'none'
        ) {
          element.modal.id.querySelector(
            '[data-value-id="' + item.id + '"]'
          ).style.display = 'flex';
        }
      });
    }
  });
}

document.body.addEventListener('composable::refreshPrice', function (e) {
  e.preventDefault();

  let finalPrice = parseFloat(window.optionModalConfig.basePrice);
  const optionValueContainers = document.querySelectorAll(
    '.option-value-container.selected'
  );

  optionValueContainers.forEach((v) => {
    const currentProductPartType = v.getAttribute('data-option-id');
    const currentProductID = v.getAttribute('data-value-id');

    if (currentProductID && currentProductPartType) {
      if (window.optionModalConfig.hasOwnProperty(currentProductPartType)) {
        window.optionModalConfig[currentProductPartType].every((k) => {
          if (k.id === currentProductID && k.price.sales.value) {
            finalPrice =
              parseFloat(finalPrice) + parseFloat(k.price.sales.decimalPrice);
            return false;
          }
          return true;
        });
      }
    }
  });

  updatePriceElements(finalPrice);
});

document.body.addEventListener('product:afterAddToCart', function (e) {
  var addToCartButton = document.querySelector(
    '.js-button-options-add-to-cart'
  );

  var data = e.detail.data;
  if (typeof data.pliUUID !== 'undefined') {
    var pliUUIDInput = document.querySelector(
      '#productOptionsModal .prescription-form input[name="pliUUID"]'
    );
    if (pliUUIDInput) {
      pliUUIDInput.value = data.pliUUID;
    }
  }

  if (!window.optionModalConfig.prescriptionStep) {
    location.href = addToCartButton.dataset.cart;
  }
});

function init() {
  window.optionModalConfig = JSON.parse(optionsModalJson);
  window.optionModalConfig.basePrice = productBasePrice;
  window.optionModalConfig.activeExceptionId = null;
  window.optionModalConfig.activeException = null;

  setGeneralListenersCreative();
  autoSelection();
  showPolarizedCheckbox();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const showproductOptionsModalUrlParameter = urlParams.get(
    'showproductOptionsModal'
  );

  if (showproductOptionsModalUrlParameter === 'true') {
    openModal();
    setHtmlUnscrollableetContainerSizeCreative();
  }
  handleOptionCheckboxesBehaviour();
}

function handleOptionCheckboxesBehaviour() {
  if (!mobileBreakpoint.matches) {
    const optionCheckboxes = element.options.optionInput;

    optionCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', optionCheckboxesMobileBehaviour);
    });
  }

  mobileBreakpoint.addEventListener('change', (event) => {
    if (!mobileBreakpoint.matches) {
      const optionCheckboxes = element.options.optionInput;
      resetCheckboxes(true);
      optionCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', optionCheckboxesMobileBehaviour);
      });
    } else {
      const optionCheckboxes = element.options.optionInput;

      optionCheckboxes.forEach((checkbox) => {
        checkbox.removeEventListener('change', optionCheckboxesMobileBehaviour);
      });
    }
  });
}

function optionCheckboxesMobileBehaviour(e) {
  e.preventDefault();
  let checkbox = e.target;

  if (!checkbox.checked) {
    checkbox.checked = true;
    return;
  }

  resetCheckboxes(false);
  checkbox.checked = true;
}

function resetCheckboxes(markFirst) {
  const optionCheckboxes = element.options.optionInput;

  optionCheckboxes.forEach((checkbox) => {
    checkbox.checked = false;
  });

  if (markFirst) {
    optionCheckboxes[0].checked = true;
  }
}

document.body.addEventListener('product:selectOptionsModal', function () {
  if (element.modal.id) {
    openModal();
  }
});

document.addEventListener('product:updateOptionsModal', function () {
  if (element.modal.id) {
    window.optionModalConfig = JSON.parse(optionsModalJson);
    window.optionModalConfig.basePrice = productBasePrice;
    window.optionModalConfig.activeExceptionId = null;
    window.optionModalConfig.activeException = null;
  }
});

document.addEventListener('DOMContentLoaded', function () {
  if (element.modal.id) {
    init();
  }
});
